import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import i18n from "./i18n"; // Import i18n setup
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme"; // your custom theme file
import { createTheme } from "@mui/material/styles";

// Use MUI default theme:
const defaultTheme = createTheme();

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {}; // optional to keep
  // Keep errors, but you can still send them securely
  const origError = console.error;
  console.error = (...args) => {
    origError(...args); // show in browser console
    // sendToMonitoringService(args); // optional
  };
}

if (process.env.NODE_ENV === "production") {
  window.addEventListener("error", (event) => {
    // sendToMonitoringService(event.error);
  });
  window.addEventListener("unhandledrejection", (event) => {
    // sendToMonitoringService(event.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <CssBaseline />
        <App />
      </HelmetProvider>
    </ThemeProvider>
  </I18nextProvider>
  // </React.StrictMode>
);

reportWebVitals();
